<section #containerBlog id="containerBlog" class="section blog">

  <!-- Wrapper-Panel -->
  <div class="wrapper-blog-panel">

    <!-- List-Panel -->
    <div class="blog-wrapper" #blogWrapper>
      <div #blogGrid class="blog-grid" appHideShellOnScroll [scrollKey]="'blog-list'" [hideNav]="false"
        [hideDock]="true" [hideFooter]="false">
        <div *ngFor="let post of posts; let i = index" class="blog-item">
          <h4 [attr.data-translate]="'BLOG.POSTS.' + i + '.TITLE'">
            {{ post.TITLE }}
          </h4>
          <p [attr.data-translate]="'BLOG.POSTS.' + i + '.DESCRIPTION'">
            {{ post.DESCRIPTION }}
          </p>
          <div class="blog-icon">
            <a href="#" (click)="openBlog(i); $event.preventDefault()">
              <i class="bx bx-arrow-back"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Detail-Panel -->
    <div #blogDetailsPanel class="blog-details-panel" id="blogDetailsPanel">
      <div class="scroll-bleed" #detailsScroll appHideShellOnScroll [scrollKey]="'blog-details'" [hideNav]="true"
        [hideDock]="true" [hideFooter]="true">
        <div class="close-btn-wrapper">
          <button class="close-btn" (click)="closeBlog()">✕</button>
        </div>

        <div class="details-content">
          <app-cube-portfolio *ngIf="activeBlogIndex === 0" [darkMode]="darkMode"></app-cube-portfolio>
          <app-dark-light-mode *ngIf="activeBlogIndex === 1" [darkMode]="darkMode"></app-dark-light-mode>
          <app-design-decision *ngIf="activeBlogIndex === 2" [darkMode]="darkMode"></app-design-decision>
          <app-design-intention *ngIf="activeBlogIndex === 3" [darkMode]="darkMode"></app-design-intention>
          <app-coolify *ngIf="activeBlogIndex === 4" [darkMode]="darkMode"></app-coolify>
          <app-etl-in-finance *ngIf="activeBlogIndex === 5" [darkMode]="darkMode"></app-etl-in-finance>
        </div>
      </div>

    </div>
  </div>

  <app-footer (toggleImprint)="toggleImprint.emit()" (togglePrivacy)="togglePrivacy.emit()"></app-footer>

</section>
